import { IconType, SvgIcon } from './SvgIcon';

export const ReloadIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M2.5 10.5C2.5 11.9834 2.93987 13.4334 3.76398 14.6668C4.58809 15.9001 5.75943 16.8614 7.12987 17.4291C8.50032 17.9968 10.0083 18.1453 11.4632 17.8559C12.918 17.5665 14.2544 16.8522 15.3033 15.8033C16.3522 14.7544 17.0665 13.418 17.3559 11.9632C17.6453 10.5083 17.4968 9.00032 16.9291 7.62987C16.3614 6.25943 15.4001 5.08809 14.1668 4.26398C12.9334 3.43987 11.4834 3 10 3C7.90329 3.00789 5.89081 3.82602 4.38333 5.28333L2.5 7.16667"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 3V7.16667H6.66667"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

ReloadIcon.displayName = 'ReloadIcon';
